/**
 * expected statuses of stripe payment response
 * @TODO Alex: move to core
 */
export enum StripeResponseStatusEnum {
  SUCCEEDED = 'succeeded',
  PROCESSING = 'processing',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method'
}
